import { type BasePageData } from '@finn/ui-cosmic';

import { FilterValuesObject } from '../helpers/filters';
import { ProductGroupBy } from '../hooks/useProductListItems';
import { type FiltersType } from '../hooks/useProductListItems';
import { GenericVehicleDetails } from '../types';
import { defaultApiConfig } from './api-config';
import { type DiscoveryConfigContextType } from './MetadataProvider';
import {
  fetchAdjustedProductListItems,
  fetchProductItems,
} from './ssr-fetchers';
import { fetchFilters, fetchProduct, fetchProducts } from './ssr-raw-fetchers';

export type GetVehiclesParams = {
  locale: string;
  filters?: FilterValuesObject;
  offset?: number;
  limit?: number;
  groupBy?: ProductGroupBy;
};

export type GetVehiclesResponse = {
  offset: number;
  total_results: number;
  results?: GenericVehicleDetails[];
};

export const createProductFetchers = (
  apiConfig: DiscoveryConfigContextType['apiConfig'] = defaultApiConfig
) => {
  return {
    fetchProducts: (params: Parameters<typeof fetchProducts>['1']) =>
      fetchProducts({ apiConfig }, params),
    fetchProduct: (params: Parameters<typeof fetchProduct>['1']) =>
      fetchProduct({ apiConfig }, params),
    fetchFilters: (params: Parameters<typeof fetchFilters>['1']) =>
      fetchFilters({ apiConfig }, params),
    fetchAdjustedProductListItemsResponse: (
      filterValues: FilterValuesObject,
      locale: string,
      pageData?: BasePageData
    ) =>
      fetchAdjustedProductListItems(
        { apiConfig },
        {
          filterValues,
          pageData,
          locale,
        }
      ),
    fetchProductItems: async ({
      locale,
      slugArray,
      availableFilters,
      displayedFilters,
      pageData,
      groupBy,
    }: {
      locale?: string;
      slugArray?: string[];
      availableFilters?: FiltersType;
      displayedFilters: FiltersType;
      pageData?: BasePageData;
      groupBy?: ProductGroupBy;
    }) =>
      fetchProductItems(
        { apiConfig },
        {
          locale,
          slugArray,
          availableFilters,
          displayedFilters,
          pageData,
          groupBy,
        }
      ),
  };
};
